export default "__VITE_ASSET__BUS7twr___"